import {TabPanel, TabView} from 'primereact/tabview';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import {CustomMessages} from '../components/CustomMessages';
import BlockUi from '../components/waitPanel/BlockUi';
import CardService from '../services/CardService';
import CardListContainer from './CardListContainer';
import MobileUserListContainer from './MobileUserListContainer';
import OrderCardDialog from './OrderCardDialog';
import HybridCardUserApprovalsDialog from './HybridCardUserApprovalsDialog';

class CardMobileUserContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.cardService = new CardService();
        this.state = {
            activeIndex: 0,
            yourCardCount: 0,
            virtualCardUsersCount: 0,
            orderCardVisibile: false,
            hybridAgreementsVisibile: false,
            allAprrovalAccepted: false,
            approvals: [],
            element:{
                approvals:[]
            },
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleOrderCardDialogOpen = this.handleOrderCardDialogOpen.bind(this);
        this.handleOrderCardDialogClose = this.handleOrderCardDialogClose.bind(this);
        this.updateUsersCountOnTab = this.updateUsersCountOnTab.bind(this);
        this.updateCardsCountOnTab = this.updateCardsCountOnTab.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK') {
        this.getHybridCardUserApprovalsToAccept();
        }
        let cardsCount = this.readCookie('cards-count-list');
        if (cardsCount === undefined || cardsCount === null || cardsCount === '') {
            cardsCount = 0;
        }
        this.setState({yourCardCount: parseInt(cardsCount)});
        let activeIndex = this.readCookie(`card-mobile-user-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.setState({activeIndex: parseInt(activeIndex)});
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`card-mobile-user-activeIndex`, this.state.activeIndex);
            }
        );
    }

    getHybridCardUserApprovalsToAccept(){

        this.cardService.getHybridCardUserApprovalsToAccept()
        .then((response)=> this.setState({approvals: response}))
        .catch((error) =>{
            this.showErrorMessage("Wystąpił błąd podczas pobierania regulaminów dla uzytkownika karty hybrydowej")
        })
    }

    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }

    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    checkTokenIfAllHybridAgreementNotAccepted(){
        const hybridCardUser = (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK') ;
        if(hybridCardUser === true){
            const listOfAcceptedTerms = this.authService.getHybridCardUserAcceptedTerms();
            return this.state.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId)).length > 0;
        } else {
            return false;
        }
    }

    handleOrderCardDialogOpen() {  
         this.setState({orderCardVisibile: true});
    }

    handleOrderCardDialogClose(callback) {
        this.setState({orderCardVisibile: false, hybridAgreementsVisibile : false}, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleHybridAgreementDialogClose(callback) {
        if(this.checkTokenIfAllHybridAgreementNotAccepted() === false){
            this.setState({orderCardVisibile: true, hybridAgreementsVisibile : false}, () => {
                if (callback) {
                    callback();
                }
            });
        } else {
            this.setState({orderCardVisibile: false, hybridAgreementsVisibile : false}, () => {
                if (callback) {
                    callback();
                }
            });
        }
      
    }

    updateCardsCountOnTab(res) {
        this.setState({
            virtualCardUsersCount: res.all?.totalElements,
        });
    }

    updateUsersCountOnTab(res) {
        const cardsCount = res.allList?.totalElements;
        this.saveCookie('cards-count-list', JSON.stringify(cardsCount));
        this.setState({
            virtualCardUsersCount: res.usersCount,
            yourCardCount: cardsCount,
        });
    }

        getOnlyNotAcceptedHybridCardUserApprovals(){
        const listOfAcceptedTerms = this.authService.getHybridCardUserAcceptedTerms();
      return  this.state.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId));
    }

    render() {
        const {t} = this.props;
              return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <div className='container-fluid card-mobile-user-container'>
                        <OrderCardDialog onHide={() => this.handleOrderCardDialogClose()} visible={this.state.orderCardVisibile} agreementsToAccept={this.getOnlyNotAcceptedHybridCardUserApprovals()} className='order-card-dialog' />
                        <div className='header-dialog-button-container'>
                            <ActionButton
                                label={t('cards.orderCard')}
                                variant='left-button save-button blue '
                                handleClick={this.handleOrderCardDialogOpen}
                                disabled={!this.isUserHasPermission('PERMISSION_FULL_ACCESS_ORDERS')}
                            />
                        
                       </div>

                    



                        {/* </div> */}

                    {this.state.hybridAgreementsVisibile ? (
                    <HybridCardUserApprovalsDialog
                        id={`agreement-term-dialog`}
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        approvals={this.state.approvals}
                        visible={this.state.hybridAgreementsVisibile}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.props.showMessage}
                        resizable={true}
                        className='agreement-term-dialog'
                        key={`agreement-term-dialog`}
                        handleReject={() => {}}
                        closable={false}
                        onHide= {() => this.handleHybridAgreementDialogClose()}
                        handleError={err => this.showErrorMessage(err)}
                    ></HybridCardUserApprovalsDialog>) : null}

                        <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange}>
                            <TabPanel header={`${t('cards.yourCards')} (${this.state.yourCardCount})`}>
                                <CardListContainer
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    embedded
                                    _isMounted={this._isMounted}
                                    onAfterGetList={this.updateUsersCountOnTab}
                                />
                            </TabPanel>
                            <TabPanel header={`${t('cards.virtualCardUsers')} (${this.state.virtualCardUsersCount})`}>
                                <MobileUserListContainer
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    embedded
                                    _isMounted={this._isMounted}
                                    onAfterGetList={this.updateCardsCountOnTab}
                                />
                            </TabPanel>
                        </TabView>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}

export default withTranslation()(CardMobileUserContainer);
